import { render } from "./PageIconCardsGrid.vue?vue&type=template&id=212cfd41&ts=true"
import script from "./PageIconCardsGrid.vue?vue&type=script&lang=ts"
export * from "./PageIconCardsGrid.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__